// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__33TU0","content":"styles_content__16qAi","selectAll":"styles_selectAll__4oVOY"};